import { useEffect, useRef, useState } from "react";
import type { CreateGameFormProps } from "../../game-registry";

export function MinusAuctionCreateGameForm({
  onConfigChange,
}: CreateGameFormProps) {
  const [startingChips, setStartingChips] = useState("");
  const [startingGarnets, setStartingGarnets] = useState("2");
  const onConfigChangeRef = useRef(onConfigChange);
  onConfigChangeRef.current = onConfigChange;

  useEffect(() => {
    const config: Record<string, unknown> = {};
    const chips = Number(startingChips);
    const garnets = Number(startingGarnets);

    if (startingChips.trim() !== "" && Number.isFinite(chips)) {
      config.startingChips = Math.max(0, Math.trunc(chips));
    }
    if (Number.isFinite(garnets)) {
      config.startingGarnets = Math.max(0, Math.trunc(garnets));
    }

    onConfigChangeRef.current(config);
  }, [startingChips, startingGarnets]);

  return (
    <section className="rounded-md border border-border-subtle bg-surface-secondary p-3">
      <div className="mb-3">
        <div className="font-semibold text-sm text-text-primary">
          마이너스 경매 설정
        </div>
        <div className="mt-1 text-text-muted text-xs">
          시작 칩을 비우면 실제 시작 인원에 맞춰 자동 적용됩니다.
        </div>
      </div>
      <div className="grid gap-3 sm:grid-cols-2">
        <label className="grid gap-1.5 text-sm">
          <span className="font-semibold text-text-secondary">시작 칩</span>
          <input
            type="number"
            min={0}
            placeholder="인원별 자동"
            value={startingChips}
            onChange={(event) => setStartingChips(event.currentTarget.value)}
            className="rounded-md border border-border-primary bg-surface-primary px-3 py-2 text-text-primary"
          />
        </label>
        <label className="grid gap-1.5 text-sm">
          <span className="font-semibold text-text-secondary">시작 가넷</span>
          <input
            type="number"
            min={0}
            value={startingGarnets}
            onChange={(event) => setStartingGarnets(event.currentTarget.value)}
            className="rounded-md border border-border-primary bg-surface-primary px-3 py-2 text-text-primary"
          />
        </label>
      </div>
    </section>
  );
}
